<template>
  <div>
    <div id="user-list-print">
      <div v-for="(item,index) in list" class="user-item" :key="index">
        <div class="user-info">
          <!-- 按选中字段顺序循环渲染 -->
          <span v-for="field in printFields" :key="field.prop">
            {{ item[field.prop] }}
          </span>
        </div>
        <img :src="item.previewQrUrl" alt="" style="width: 100%;">
      </div>
    </div>
  </div>
</template>

<script setup>
import printJS from "print-js";
const printVisible = defineModel();
const props = defineProps({
  list: {
    required: true,
    type: Array,
  },
  // 新增：选中打印字段，带顺序
  printFields: {
    type: Array,
    default: () => [],
  },
});
const sexMap = {
  1: "男",
  2: "女",
}
const print = () => {
  printJS({
    printable: "user-list-print",
    type: "html",
    // css: "", // 外部css
    maxWidth: "800px",
    // header: "",
    // headerStyle: ``,
    style: `
      @page {
        size: A4;
      }
      .paging {
        page-break-after: always;
      }
      #user-list-print{
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        column-gap: 40px;
        row-gap: 20px;
      }
      .user-item{
        display: flex;
        flex-direction: column;
        gap: 10px;
        page-break-inside: avoid;
        position: relative;
      }
      /* 右侧虚线：每行最后一个不画 */
      .user-item:not(:nth-child(4n))::after {
        content: "";
        position: absolute;
        top: 0;
        right: -20px;
        width: 0;
        height: 100%;
        border-right: 1px dashed #333;
      }
      /* 底部虚线：最后一行不画 */
      .user-item:not(:nth-last-child(-n+4))::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: -10px;
        width: 100%;
        height: 0;
        border-bottom: 1px dashed #333;
      }
      .user-info{
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 10px;
      }
    `,
    scanStyles: false,
  });
  printVisible.value = false;
};
defineExpose({
  print,
});
</script>

<style lang="scss" scoped>
#user-list-print{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 40px;
  row-gap: 20px;
}
.user-item{
  display: flex;
  flex-direction: column;
  gap: 10px;
  page-break-inside: avoid;
  position: relative;
}
/* 右侧虚线：每行最后一个不画 */
.user-item:not(:nth-child(4n))::after {
  content: "";
  position: absolute;
  top: 0;
  right: -20px;
  width: 0;
  height: 100%;
  border-right: 1px dashed #333;
}
/* 底部虚线：最后一行不画 */
.user-item:not(:nth-last-child(-n+4))::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 100%;
  height: 0;
  border-bottom: 1px dashed #333;
}
.user-info{
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 10px;
}
</style>